// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__lrZRq","fadeIn":"Modal_fadeIn__R6sTS"};